import React from "react";

const DetailReportLink = ({children, date, dateServer, publisher, product, status, source, rcid}) => {
    let url = `/lead/report/details?page=1&perPage=100`;

    function formatDateToShortString(dateStr) {
        const [year, month, day] = dateStr.split('-');
        const date = new Date(Date.UTC(year, month - 1, day));
        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            timeZone: "UTC",
        });
    }

    if (date) {
       url += `&date=${date}`;
    }else if (dateServer) {
       const dateRange = `${formatDateToShortString(dateServer)} to ${formatDateToShortString(dateServer)}`;
       url += `&date=${dateRange}`;
    }

   if (publisher) {
       url += `&publisher=${publisher}`;
   }

   if (product) {
       url += `&product=${product}`;
   }

   if (status) {
       url += `&status=${status}`;
   }

    if (source) {
        url += `&source=${source}`;
    }

    if (rcid) {
        url += `&rcid=${rcid}`;
    }

   const openInNewTab = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
   };

   return <span className="cursor-pointer" onClick={()=>openInNewTab(url)}>{children}</span>
}

export default DetailReportLink;
